import Table    from '../../../../components/Table';
import View from './View';
import ViewInmueblesPersonas from './ViewInmueblesPersonas';
import usePermissions from '../../../../hooks/usePermissions';


const td  = [
  {
    label:"Inmueble",
    field:"name",
    className:"",
    align:"left",
  },
  {
    label:"Condominio",
    field:"condominio",
    className:"",
    align:"left",
  },
  {
    label:"Teléfono",
    field:"celular",
    className:"",
    align:"left",
  },
  {
    label:"Acción",
    field:"event",
    className:"",
    align:"center",
    event:[
      {
        label:"Ver",
        action:"view",
        component:View,
      },
      {
        label:"Comentarios",
        action:"comments",
        subFixed:"inmuebles_id_",
        component:true,
      },
      {
        label:"Inmuebles",
        action:"view",
        component:ViewInmueblesPersonas,
      },
    ]
  },
]

const Home=(props)=>{
  const permissions     =   usePermissions("clientes","index",{
                                                                upload:true,
                                                                component:Table,
                                                                td:td,
                                                                create:View,
                                                                subFixed:"/inmuebles"
                                                              });
  return  permissions.render()
}
export default Home
